import { useRouter } from 'helpers/customHooks';
import React, { Fragment } from 'react';
import { Table, Dropdown } from 'react-bootstrap';
import { useFiltersState } from 'store/hooks';

import { ENTITY_OFFSETS, ENTITY_VALUES, FILTER_KEYS, PRACTICE } from '../../config/constants';
import { containsBadCharacter } from '../../helpers/helpers';
import { TagsTableProps, Tag } from './types';

const TagsTable =  ({ entity, setEntity, changeTagGroupPlayer, changeTagOffsetPlayer, changeTagNamePlayer}: TagsTableProps) => {
  const { specificScope } = useRouter();
  const { [FILTER_KEYS.VENUE]:venueFilter } = useFiltersState(specificScope, FILTER_KEYS.VENUE);
  const type = venueFilter?.value?.type || 'practice';
  // tags handlers start here
  const changeTagId = (event:React.ChangeEvent<HTMLInputElement>, index:number) => {
    const value = event.target.value.replace(/\s/g, '');
      if (!containsBadCharacter(value)) {
        const newEntity = JSON.parse(JSON.stringify(entity));
        newEntity.tags[index].id = value;
        setEntity(newEntity);
    }
  };
  const changeTagName = (event:React.ChangeEvent<HTMLInputElement>, index:number) => {
    if (event.target.value !== ' ') {
      const newEntity = JSON.parse(JSON.stringify(entity));
      newEntity.tags[index].name = event.target.value;
      setEntity(newEntity);
    }
  };
  const changeTagGroup = (event:React.ChangeEvent<HTMLInputElement>, index:number) => {
    if (event.target.value !== ' ') {
      const newEntity = JSON.parse(JSON.stringify(entity));
      newEntity.tags[index].group = event.target.value;
      setEntity(newEntity);
    }
  };
  const changeTagOffset = (value:string, index:number) => {
    const newEntity = JSON.parse(JSON.stringify(entity));
    newEntity.tags[index].offset = value.split(',').map(offset => {
      return Number(offset);
    });
    setEntity(newEntity);
  };
  const changeTagActive = (index:number) => {
    const newEntity = JSON.parse(JSON.stringify(entity));
    newEntity.tags[index].active = !newEntity.tags[index].active;
    setEntity(newEntity);
  };
  const deleteTag = (index:number) => {
    const newEntity = JSON.parse(JSON.stringify(entity));
    newEntity.tags = [];
    entity!.tags.forEach((tag, i) => {
      if (i !== index) {
        newEntity.tags.push(tag);
      }
    });
    setEntity(newEntity);
  };
  //
  const selectedEntity = (entity ? entity.type : null);
  const names = type === PRACTICE ? ['HP1_left_shoulder',
      'HP1_right_shoulder',
      'HP1_center_shoulder',
      'HP2_left_shoulder',
      'HP2_right_shoulder',
      'HP2_center_shoulder',
      'AP1_left_shoulder',
      'AP1_right_shoulder',
      'AP1_center_shoulder',
      'AP2_left_shoulder',
      'AP2_right_shoulder',
      'AP2_center_shoulder',
      'C1_left_shoulder',
      'C1_right_shoulder',
      'C1_center_shoulder',
      'C2_left_shoulder',
      'C2_right_shoulder',
      'C2_center_shoulder',
      'AS1_left_shoulder',
      'AS1_right_shoulder',
      'AS1_center_shoulder']
    :
    ['PS1_left_shoulder',
      'PS1_right_shoulder',
      'PS1_center_shoulder',
      'PS2_left_shoulder',
      'PS2_right_shoulder',
      'PS2_center_shoulder',
      'PS3_left_shoulder',
      'PS3_right_shoulder',
      'PS3_center_shoulder'];
  let rows:JSX.Element[] = [];
  const tagIdField = (tag:Tag, index:number) => {
    const isDuplicate = entity!.tags.reduce((sum, t) => sum + +(t.id === tag.id), 0) > 1;
    return (
      <input
        className="input-000"
        type="text"
        value={tag.id}
        {...(isDuplicate ? { title: 'TAG ID REPEATED' } : {})}
        style={{
          ...(isDuplicate ? { borderColor: 'red' } : {}),
          width: '137px',
          padding: '6px 8px'
        }}
        onChange={(event) => changeTagId(event, index)}
      />
    );
  };
  const groupField = (tag:Tag, index:number) => (
    <input
      className="input-002"
      type="text"
      value={tag.group}
      style={{ width: '126px', padding: '6px 8px' }}
      onChange={(event) => changeTagGroup(event, index)}
    />
  );
  const offsetField = (tag:Tag, index:number) => (
    <Dropdown className={'dropdown-basic-offset-selector'}>
      <Dropdown.Toggle style={{ width: '114px', padding: '6px 8px' }} id="dropdown-basic" className="btn-gray-l">
        {tag.offset ? tag.offset.join() : 'Select'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {ENTITY_OFFSETS.map((offset, offsetIndex) =>
          <Dropdown.Item key={offsetIndex} onClick={() => changeTagOffset(offset, index)}>
            {offset}
          </Dropdown.Item>)}
      </Dropdown.Menu>
    </Dropdown>
  );
  const activeField = (tag:Tag, index:number) => <>
    <input type="checkbox" id={`id-active--${index}`} name="set-name"
           className="switch-input"
           style={{ marginLeft: '10px' }}
           checked={tag.active}
           onChange={() => changeTagActive(index)} />
    <label htmlFor={`id-active--${index}`} className="switch-label" /></>;
  const deleteField = (tag:Tag, index:number) => <i className="mdi mdi-delete" style={{ fontSize: '23px', cursor: 'pointer' }}
                                         onClick={() => {
                                           deleteTag(index);
                                         }} />;

  if (entity!.tags.length > 0 && selectedEntity === ENTITY_VALUES.PLAYER) {
    entity!.tags.forEach((tag, index) => {
      if(tag && tag.name){
      const nameParts = tag!.name!.split('_');
      const HP1 = nameParts.find((segment) => segment.toLowerCase() === 'hp1');
      const HP2 = nameParts.find((segment) => segment.toLowerCase() === 'hp2');
      const AP1 = nameParts.find((segment) => segment.toLowerCase() === 'ap1');
      const AP2 = nameParts.find((segment) => segment.toLowerCase() === 'ap2');
      const C1 = nameParts.find((segment) => segment.toLowerCase() === 'c1');
      const C2 = nameParts.find((segment) => segment.toLowerCase() === 'c2');
      const AS1 = nameParts.find((segment) => segment.toLowerCase() === 'as1');
      const Left = nameParts.find((segment) => segment.toLowerCase() === 'left');
      const Right = nameParts.find((segment) => segment.toLowerCase() === 'right');
      const Center = nameParts.find((segment) => segment.toLowerCase() === 'center');
      const PS1 = nameParts.find((segment) => segment.toLowerCase() === 'ps1');
      const PS2 = nameParts.find((segment) => segment.toLowerCase() === 'ps2');
      const PS3 = nameParts.find((segment) => segment.toLowerCase() === 'ps3');

      if (HP1) {
        if (tag.group === '' || tag.group !== 'Home Prac Jers 1') {
          changeTagGroupPlayer('Home Prac Jers 1', index);
        }
      } else if (HP2) {
        if (tag.group === '' || tag.group !== 'Home Prac Jers 2') {
          changeTagGroupPlayer('Home Prac Jers 2', index);
        }
      } else if (AP1) {
        if (tag.group === '' || tag.group !== 'Away Prac Jers 1') {
          changeTagGroupPlayer('Away Prac Jers 1', index);
        }
      } else if (AP2) {
        if (tag.group === '' || tag.group !== 'Away Prac Jers 2') {
          changeTagGroupPlayer('Away Prac Jers 2', index);
        }
      } else if (C1) {
        if (tag.group === '' || tag.group !== 'Compression 1') {
          changeTagGroupPlayer('Compression 1', index);
        }
      } else if (C2) {
        if (tag.group === '' || tag.group !== 'Compression 2') {
          changeTagGroupPlayer('Compression 2', index);
        }
      } else if (AS1) {
        if (tag.group === '' || tag.group !== 'Alt Pad Set 1') {
          changeTagGroupPlayer('Alt Pad Set 1', index);
        }
      } else if (PS1) {
        if (tag.group === '' || tag.group !== 'Pad Set 1') {
          changeTagGroupPlayer('Pad Set 1', index);
        }
      } else if (PS2) {
        if (tag.group === '' || tag.group !== 'Pad Set 2') {
          changeTagGroupPlayer('Pad Set 2', index);
        }
      } else if (PS3) {
        if (tag.group === '' || tag.group !== 'Pad Set 3') {
          changeTagGroupPlayer('Pad Set 3', index);
        }
      } else {
        if (tag.group !== '') {
          changeTagGroupPlayer('', index);
          if (tag.name !== 'Select') {
            changeTagNamePlayer('Select', index);
          }
        }
      }
      if (Left) {
        if (!tag.offset || JSON.stringify(tag.offset) !== '[0.5,0,0]') {
          changeTagOffsetPlayer('0.5,0,0', index);
        }
      } else if (Right) {
        if (!tag.offset || JSON.stringify(tag.offset) !== '[-0.5,0,0]') {
          changeTagOffsetPlayer('-0.5,0,0', index);
        }
      } else if (Center) {
        if (!tag.offset || JSON.stringify(tag.offset) !== '[0,0,0]') {
          changeTagOffsetPlayer('0,0,0', index);
        }
      }
    }

      rows.push((
        <Fragment key={index}>
          <tr>
            <td>
              {tagIdField(tag, index)}
            </td>
            <td>
              <Dropdown className={'dropdown-basic-name-tag-selector'}>
                <Dropdown.Toggle style={{ width: '137px', padding: '6px 8px' }} id="dropdown-basic"
                                 className="btn-gray-l">
                  {tag.name ? tag.name : 'Select'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {names.map((name, namesetIndex) =>
                    <Dropdown.Item key={namesetIndex} onClick={() => changeTagNamePlayer(name, index)}>
                      {name}
                    </Dropdown.Item>)}
                </Dropdown.Menu>
              </Dropdown>
            </td>
            <td>
              {groupField(tag, index)}
            </td>
            <td>
              {offsetField(tag, index)}
            </td>
            <td>
              {activeField(tag, index)}
            </td>
            <td>
              {deleteField(tag, index)}
            </td>
          </tr>
        </Fragment>
      ));
    });
  } else {
    if (entity!.tags.length > 0 && selectedEntity === ENTITY_VALUES.BALL) {
      entity!.tags.forEach((tag, index) => {
        if (tag.name === '' || tag.name !== 'TS1_tag') {
          changeTagNamePlayer('TS1_tag', index);
        }
        if (tag.group === '' || tag.group !== 'Tag Set 1') {
          changeTagGroupPlayer('Tag Set 1', index);
        }
        if (!tag.offset || JSON.stringify(tag.offset) !== '[0,0,0]') {
          changeTagOffsetPlayer('0,0,0', index);
        }
      });
    }
    if (entity!.tags.length > 0) {
      rows = entity!.tags.map((tag, index) => (
        <Fragment key={index}>
          <tr>
            <td>
              {tagIdField(tag, index)}
            </td>
            <td>
              <input className="input-001" type="text" value={tag.name} style={{ width: '137px', padding: '6px 8px' }}
                     onChange={(event) => changeTagName(event, index)} />
            </td>
            <td>
              {groupField(tag, index)}
            </td>
            <td>
              {offsetField(tag, index)}
            </td>
            <td>
              {activeField(tag, index)}
            </td>
            <td>
              {deleteField(tag, index)}
            </td>
          </tr>
        </Fragment>));
    }
  }
  return <>
    <div className="ex-entities-tags">
      <Table responsive="sm">
        <thead style={{ background: 'white !important' }}>
        <tr>
          <th className="t-ll th" style = {{width:"152px"}}>TAG ID</th>
          <th className="t-ll th" style = {{width:"152px"}}>NAME</th>
          <th className="t-ll th" style = {{width:"141px"}}>GROUP</th>
          <th className="t-ll th" style = {{width:"130px"}}>OFFSET</th>
          <th className="t-ll th th-style">ACTIVE</th>
          <th className="t-ll th th-style">DELETE</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
    </div>
  </>;
};

export default TagsTable;
